import { AxiosError } from "axios";

import { http } from "../http/HttpService";
import { registerGlobalService } from "../service-provider/ServiceRegistry";
import ApiErrorFactory from "./ApiErrorFactory";
import { configuration } from "../configuration/ConfigurationService";
import { authentication } from "../authentication/Authentication";
import { globalModule } from "../service-provider/GlobalModule";
import { Endpoint } from "./ApiEndpoints";
import { appSessionStorage } from "../storage/SessionStorageService";
import { OrganizationKey } from "../organization/LastAccessedOrganizationStorage";

export interface ApiSubscriptionKey {
  get: (endpoint: Endpoint) => Promise<any>;
}

export class ApiSubscriptionKeyService implements ApiSubscriptionKey {
  get = async (endpoint: Endpoint) => {
    let configurationContent = await configuration.get();

    try {
      const request = await this.getRequest(
        configurationContent,
        "application/json; charset=utf-8; application/problem+json"
      );

      const endpointUrl = this.getEndpointUrl(endpoint);
      let response = await http.get(configurationContent.api + endpointUrl, request);
      return response.data;
    } catch (err) {
      throw ApiErrorFactory.create(err as AxiosError<any>);
    }
  };

  private async getRequest(configurationContent: any, contentType: string) {
    const accessToken = await authentication.getAccessToken();
    const organizationId = appSessionStorage.getStorageItem(OrganizationKey);

    return {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": contentType,
        OrganizationId: organizationId || "",
        "Ocp-Apim-Subscription-Key": configurationContent.subscription_key,
      },
    };
  }

  private getEndpointUrl(endpoint: Endpoint) {
    let parsedEnpoint = endpoint;
    endpoint.routeParams?.forEach((element, index) => {
      parsedEnpoint.url = endpoint.url.replace("{" + index + "}", element.toString());
    });

    if (endpoint.queryParams) parsedEnpoint.url = `${parsedEnpoint.url}?${endpoint.queryParams}`;

    return parsedEnpoint.url;
  }
}

export const apiSubscriptionKey = new ApiSubscriptionKeyService();
globalModule.apiSubscriptionKey = apiSubscriptionKey;
export default registerGlobalService(apiSubscriptionKey as ApiSubscriptionKeyService);
